import axios from 'axios'
import {FilterModel} from '../../models/FilterModel'
import {SearchResultModel} from '../../models/SearchResultModel'
import {SubmissionModel} from '../../models/SubmissionModel'
import {SubmissionLogModel} from '../../models/SubmissionLogModel'

export const searchSubmissions = (filter?: FilterModel) =>
  axios.post<SearchResultModel<SubmissionModel>>(`/submission/list`, filter)

export const searchSubmissionLogs = (code: string, filter?: FilterModel,) =>
  axios.post<SearchResultModel<SubmissionLogModel>>(`/submission/logs/${code}`, filter)

export const approveSubmission = (code: string) =>
  axios.put(`/submission/update/status`, {code, status: 'qualified'})

export const incompleteSubmission = (code: string, note: string) =>
  axios.put(`/submission/update/status`, {code, status: 'incomplete', note})

export const shortlistSubmission = (code: string, note: string) =>
  axios.post(`/submission/recommendation`, {code, note})

export const reviewSubmission = (code: string) =>
  axios.put(`/submission/update/status`, {code, status: 'reviewed'})

export const sendResubmissionLink = (code: string) =>
  axios.post(`/submission/resubmission-link`, {code})

  export const voteSubmission = (code: string, vote: number) =>
  axios.post(`/submission/vote`, {code, vote})

export const rejectSubmission = (code: string, reason: string) =>
  axios.put(`/submission/update/status`, {code, status: 'disqualified', reason})

export const rateSubmission = (submissionCode: string, ratings: any) =>
  axios.post(`/submission/rating`, {submissionCode, ratings})

export const getSubmissionByCode = (code: string) =>
  axios.get<SubmissionModel>(`/submission/${code}`)

export const downloadSubmissionFile = (code: string) =>
  axios.post<Blob>(`/submission/download`, {code}, {responseType: 'blob'})
